import { createStore as reduxCreateStore,combineReducers,applyMiddleware,compose } from 'redux';
//import logger from 'redux-logger';
import thunk from 'redux-thunk'
import { routerReducer,routerMiddleware } from 'react-router-redux';
import { reducer as reduxFormReducer } from 'redux-form';
import * as reducers from './reducers';

export default function createStore(history){

  // reducer
  const reducer = combineReducers({
    ...reducers,
    router: routerReducer,
    form:reduxFormReducer,
  });

  // middleware
  const middleware = applyMiddleware(
    //logger,
    thunk,
    routerMiddleware(history)
  );

  // store
  return reduxCreateStore(
    reducer,
    compose(middleware, window.devToolsExtension ? window.devToolsExtension() : f => f)
  )
}


// WEBPACK FOOTER //
// ./src/store.js